// extracted by mini-css-extract-plugin
export default {"card":"photo-grid_card__77wcE","photoGrid":"photo-grid_photoGrid__JsmGI","cardTall":"photo-grid_cardTall__aAgwp","cardWide":"photo-grid_cardWide__r5Z8u"};